import currenciesJSON from "@/assets/json/currencies.json"

var mixin = {
  data() {
    return {
      currencyCode: "TWN"
    }
  },
  methods: {
    getCurrency: code => {
      return currenciesJSON.find(item => {
        return item.code == code
      })
    },
    getCurrencySymbol: code => {
      var currency = currenciesJSON.find(item => {
        return item.code == code
      })
      if (currency != undefined) {
        return currency.symbol
      }
      // return currenciesJSON.find(item => {
      //     return item.code == code
      // }).symbol
    },
    getAmountWithCurrency: (amount, code) => {
      if (!amount) {
        amount = 0
      }
      if (!code) return parseFloat(amount.toFixed(2))

      var amountAbs = numberWithCommas(Math.abs(amount.toFixed(2)))
      var currencySymbol = getCurrencySymbol(code)

      if (amount < 0) {
        return "- " + currencySymbol + " " + amountAbs
      } else {
        return currencySymbol + " " + amountAbs
      }
    }
  },
  created() {
    this.currencyCode = this.$store.getters["bizes/currencyCode"]()
  }
}

function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function getCurrencySymbol(code) {
  var currency = currenciesJSON.find(item => {
    return item.code == code
  })
  if (currency != undefined) {
    return currency.symbol
  }
}

export { mixin, getCurrencySymbol }
